export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const SEVERITY_COLORS = {
  CRITICAL: 'bg-red-600',
  HIGH: 'bg-orange-500',
  MODERATE: 'bg-yellow-500',
  COMPLIANT: 'bg-green-500',
};

export const SEVERITY_TEXT_COLORS = {
  CRITICAL: 'text-red-600',
  HIGH: 'text-orange-500',
  MODERATE: 'text-yellow-500',
  COMPLIANT: 'text-green-600',
};